import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AbstractControl, FormControl } from '@angular/forms';
import { inputValidator } from '@b2b/features/cart/helpers/import-validators';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputFieldComponent } from '@shared/components/form-elements/input-field/input-field.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'import-error',
  imports: [CommonModule, RouterModule, TableModule, ButtonComponent, InputFieldComponent, TranslateModule],
  templateUrl: './import-error.component.html',
  styleUrl: './import-error.component.scss',
})
export class ImportErrorComponent {
  @Input() control?: AbstractControl | null;

  fileControl = new FormControl(null, {
    validators: [inputValidator()],
  });

  eanControl = new FormControl(null, {
    validators: [inputValidator()],
  });
  quantityControl = new FormControl(null, {
    validators: [inputValidator()],
  });

  constructor() {}
}
